export const routesList = {
  home: "/",
  about: "/about",
  projects: "/projects",
  resume: "/resume",
}